var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-summary-card',{attrs:{"entry":_vm.item,"buffSources":_vm.buffSources,"getEffectsFromSource":_vm.getEffectsFromSource},scopedSlots:_vm._u([{key:"value-header",fn:function(ref){
var entry = ref.entry;
return _c('span',{},[_vm._v("\n    "+_vm._s(_vm.getHeaderTextForSource(entry))+"\n  ")])}}])},[_c('span',{attrs:{"slot":"allentrypreview"},slot:"allentrypreview"})])}
var staticRenderFns = []

export { render, staticRenderFns }